import { Ti18nKeys } from "./i18n";
import { DEFAULT_TIME } from "./input-entries-constants";
import {
  ALL_COUNTRY_PICKER_ENTRIES,
  DEFAULT_ET3_PICKER_SINGLE_VALUE
} from "./picker-entries-constants";
import {
  TKhattabatFeatureBadge,
  TPaidUsersInformation,
  TUserKeys,
  TUserSubscriptionStatus
} from "../Types";
import { ColorsEnum } from "../core/et3-theme/colors";

export const minAge = 18;
export const maxAge = 77;

export const minHeight = 120;
export const maxHeight = 219;

export const minWeight = 30;
export const maxWeight = 119;

export const USER_ADVANCED_PHOTO_SIZE = 224;

export const USER_ADVANCED_CRITERIA_FIELD_SIZE = { xs: 12, sm: 6, md: 3 };

export const KHATTABAT_MATCHING_FIELD_SIZE = { xs: 12, sm: 6, md: 4, lg: 3 };

export const MIN_USER_ADVANCED_CRITERIA_SEARCH_NUMBER = 3;

export const COUNTRIES = () => {
  let countries = [DEFAULT_ET3_PICKER_SINGLE_VALUE];
  return countries.concat(ALL_COUNTRY_PICKER_ENTRIES);
};

const numberPicker = ({
  minValue,
  maxValue
}: {
  minValue: number;
  maxValue: number;
}) => {
  const arrayConstructor = Array.from(Array(maxValue + 1).keys());
  const arrayLimits = arrayConstructor.filter((val) => {
    return val >= minValue && val <= maxValue;
  });
  const filledArray = arrayLimits.map((acceptedValue) => {
    return { label: `${acceptedValue}`, value: `${acceptedValue}` };
  });
  return [DEFAULT_ET3_PICKER_SINGLE_VALUE, ...filledArray];
};

export const ALLOWED_AGES = numberPicker({
  minValue: minAge,
  maxValue: maxAge
});

export const ALLOWED_HEIGHTS = numberPicker({
  minValue: minHeight,
  maxValue: maxHeight
});

export const ALLOWED_WEIGHTS = numberPicker({
  minValue: minWeight,
  maxValue: maxWeight
});

export const USER_DEFAULT_DATA = [
  {
    userId: 0,
    userUUID: "",
    username: "",
    statusChangeDate: "",
    gender: "",
    religion: "",
    subreligion: "",
    status: "",
    isSilentBanned: 0,
    emailStatus: "",
    facebookVerify: "",
    smsVerify: "",
    emailVerify: "",
    appleVerify: "",
    emailNotification: "",
    pushNotification: "",
    descriptionID: -1,
    description: "",
    descriptionStatus: "",
    descriptionLanguage: "",
    peerDescriptionID: -1,
    peerDescription: "",
    peerDescriptionStatus: "",
    peerDescriptionLanguage: "",
    createdOn: "",
    createdFrom: "",
    originCountry: "",
    residenceCountry: "",
    cityName: "",
    selfieVerificationCompletedOn: "",
    numberOfVerifiedApprovedPictures: 0,
    loginCount: 0,
    state: "",
    ipAddress: "",
    verificationStatus: "",
    verificationCode: "",
    referralCode: "",
    mobileAppPlatform: "",
    mobileAppVersion: "",
    deviceId: "",
    device_token: "",
    isFlagged: 0,
    reportsSent: 0,
    reportsReceived: 0,
    temporaryBannedCount: 0,
    warningCount: 0,
    userUnderCSRInvestigation: false,
    userUnderInvestigationAndReadyToResolve: false,
    userUnderCSRReport: 0,
    wasPaying: false,
    isPaidVIP: false,
    isPaidPlus: false,
    isPaidAlkhattabat: false,
    isPaidBoost: false,
    isPaidRewind: false,
    isPaidSilver: false,
    isPaidGold: false,
    isPaidPlatinum: false,
    isPaidPower: false,
    isSubscribedVIP: false,
    isSubscribedPlus: false,
    isSubscribedAlkhattabat: false,
    isSubscribedBoost: false,
    isSubscribedRewind: false,
    isSubscribedSilver: false,
    isSubscribedGold: false,
    isSubscribedPlatinum: false,
    isSubscribedPower: false,
    lastLogin: 0,
    payingKhattabatUntil: DEFAULT_TIME,
    freemiumVIPUntil: DEFAULT_TIME,
    freemiumPLUSUntil: DEFAULT_TIME,
    freemiumSilverUntil: DEFAULT_TIME,
    freemiumGoldUntil: DEFAULT_TIME,
    freemiumPlatinumUntil: DEFAULT_TIME,
    payingVIPUntil: DEFAULT_TIME,
    payingPLUSUntil: DEFAULT_TIME,
    payingBOOSTUntil: DEFAULT_TIME,
    payingREWINDUntil: DEFAULT_TIME,
    payingSilverUntil: DEFAULT_TIME,
    payingGoldUntil: DEFAULT_TIME,
    payingPlatinumUntil: DEFAULT_TIME,
    payingPowerUntil: DEFAULT_TIME,
    userAppLanguage: "",
    isTester: false,
    deactivatedOn: DEFAULT_TIME,
    deactivationCounter: 0,
    phoneDetails: "",
    profilePublicID: "",
    khattabaAssigned: "",
    hasAccessToBoosts: false,
    hasAccessToRewinds: false,
    hasAccessToReadReceipts: false,
    hasAccessToNewConversationsDaily: false,
    hasAccessToNewConversationsWeekly: false,
    hasRemainingBoosts: false,
    hasRemainingRewinds: false,
    hasRemainingReadReceipts: false,
    hasRemainingNewConversationsDaily: false,
    hasRemainingNewConversationsWeekly: false,
    hasAccessToLikes: false,
    hasAccessToLikesDaily: false,
    hasRemainingLikes: false,
    hasRemainingLikesDaily: false,
    emails: [
      {
        userEmail: "",
        verificationPlatform: "",
        verificationActive: 0,
        userActivityEmailsSubscription: 0,
        promotionalEmailsSubscription: 0,
        newMessageEmailsSubscription: 0,
        visitProfileEmailsSubscription: 0,
        likeEmailsSubscriptio: 0,
        userActivityEmailsSettingsOn: 0,
        promotionalEmailsSettingsOn: 0,
        newMessageEmailsSettingsOn: 0,
        visitProfileEmailsSettingsOn: 0,
        likeEmailsSettingsOn: 0
      }
    ]
  }
];

export const USER_ACCOUNT_DELETIO_REASONS_ORDERED: Ti18nKeys[] = [
  "ER3ARRAF_IS_HARD_TO_USE",
  "NOT_ABLE_TO_FIND_PARTNER",
  "FOUND_PARTNER_THROUGH_ET3ARRAF",
  "FOUND_PARTNER_OUTSIDE_ET3ARRAF",
  "NOT_AS_EXPECTED",
  "OTHER_REASONS"
];

export const DELETE_ACCOUNT_HAPPY_REASON = `😁`;

export const DELETE_ACCOUNT_NORMAL_REASON = `😏`;

export const DELETE_ACCOUNT_SAD_REASON = `😔`;

export const PENDING_RECEIPT_TITLES: Ti18nKeys[] = [
  "RECEIPT_HAS_PENDING",
  "RECEIPT_PRODUCT_ID",
  "RECEIPT_EXPIRATION_INTENT",
  "RECEIPT_IS_IN_BILLING_RETRY",
  "RECEIPT_ORIGINAL_TRANSACTION_ID",
  "RECEIPT_AUTO_RENEW_STATUS",
  "RECEIPT_AUTO_RENEW_PRODUCT_ID"
];

export const KHATTABAT_MATCHING_USER_INFORMATION_DEFAULT: TPaidUsersInformation =
  {
    alkhatabaUUID: "",
    userUUID: "",
    userId: -1,
    userName: "",
    gender: "",
    userStatus: "",
    isActivePaidUser: 0,
    totalUnreadMessages: 0
  };

export const ACCOUNT_CREATED_ON_DATE_RANGES = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Yesterday", value: "YESTERDAY" },
  { label: "Last week", value: "LAST_WEEK" },
  { label: "Last 2 weeks", value: "LAST_2_WEEKS" },
  { label: "Last month", value: "LAST_MONTH" },
  { label: "Last 3 months", value: "LAST_3_MONTHS" },
  { label: "Last 6 months", value: "LAST_6_MONTHS" }
];

export const KHATTABAT_USER_FEATURE_SETS = (
  status: TUserSubscriptionStatus
): TKhattabatFeatureBadge[] => [
  {
    tagKey: "SILVER_TAG",
    isPaid: status.isPaidSilver,
    isSubscribed: status.isSubscribedSilver,
    color: ColorsEnum.plumBrown
  },
  {
    tagKey: "GOLD_TAG",
    isPaid: status.isPaidGold,
    isSubscribed: status.isSubscribedGold,
    color: ColorsEnum.bronzedGold
  },
  {
    tagKey: "PLATINUM_TAG",
    isPaid: status.isPaidPlatinum,
    isSubscribed: status.isSubscribedPlatinum,
    color: ColorsEnum.mutedSteelBlue
  },
  {
    tagKey: "VIP",
    isPaid: status.isPaidVIP,
    isSubscribed: status.isSubscribedVIP,
    color: ColorsEnum.vipGold
  },
  {
    tagKey: "PLUS",
    isPaid: status.isPaidPlus,
    isSubscribed: status.isSubscribedPlus,
    color: ColorsEnum.purple
  },
  {
    tagKey: "KHATTABAT_TAG",
    isPaid: status.isPaidAlkhattabat,
    isSubscribed: status.isSubscribedAlkhattabat,
    color: ColorsEnum.brightCyan
  },
  {
    tagKey: "BOOST",
    isPaid: status.isPaidBoost,
    isSubscribed: status.isSubscribedBoost,
    color: ColorsEnum.vipGold
  },
  {
    tagKey: "REWIND",
    isPaid: status.isPaidRewind,
    isSubscribed: status.isSubscribedRewind,
    color: ColorsEnum.purple
  },
  {
    tagKey: "BUNDLE",
    isPaid: status.isPaidPower,
    isSubscribed: status.isSubscribedPower,
    color: ColorsEnum.powerPurple
  }
];

export const KHATTABAT_USER_ACTIVE_FEATURES = (
  status: TUserSubscriptionStatus
): TKhattabatFeatureBadge[] => [
  {
    tagKey: "BOOST",
    isPaid:
      status.hasAccessToBoosts ||
      status.isPaidVIP ||
      status.isPaidGold ||
      status.isPaidPlatinum ||
      status.isPaidPower ||
      status.isPaidBoost,
    isSubscribed:
      status.hasRemainingBoosts ||
      status.isSubscribedVIP ||
      status.isSubscribedGold ||
      status.isSubscribedPlatinum ||
      status.isSubscribedPower ||
      status.isSubscribedBoost,
    color: ColorsEnum.vipGold
  },
  {
    tagKey: "REWIND",
    isPaid:
      status.hasAccessToRewinds ||
      status.isPaidSilver ||
      status.isPaidGold ||
      status.isPaidPlatinum ||
      status.isPaidPower ||
      status.isPaidRewind,
    isSubscribed:
      status.hasRemainingRewinds ||
      status.isSubscribedSilver ||
      status.isSubscribedGold ||
      status.isSubscribedPlatinum ||
      status.isSubscribedPower ||
      status.isSubscribedRewind,
    color: ColorsEnum.purple
  },
  {
    tagKey: "READ",
    isPaid:
      status.hasAccessToReadReceipts ||
      status.isPaidGold ||
      status.isPaidPlatinum ||
      status.isPaidPower,
    isSubscribed:
      status.hasRemainingReadReceipts ||
      status.isSubscribedGold ||
      status.isSubscribedPlatinum ||
      status.isSubscribedPower,
    color: ColorsEnum.powerPurple
  },
  {
    tagKey: "CONVERSATION_BADGE",
    isPaid:
      status.hasAccessToNewConversationsDaily ||
      status.hasAccessToNewConversationsWeekly ||
      status.isPaidGold ||
      status.isPaidPlatinum,
    isSubscribed:
      status.hasRemainingNewConversationsDaily ||
      status.hasRemainingNewConversationsWeekly ||
      status.isSubscribedGold ||
      status.isSubscribedPlatinum,
    color: ColorsEnum.darkOrange
  },
  {
    tagKey: "LIKES",
    isPaid:
      status.hasAccessToLikes ||
      status.hasAccessToLikesDaily ||
      status.isPaidSilver ||
      status.isPaidGold ||
      status.isPaidPlatinum ||
      status.isPaidPlus,
    isSubscribed:
      status.hasRemainingLikes ||
      status.hasRemainingLikesDaily ||
      status.isSubscribedSilver ||
      status.isSubscribedGold ||
      status.isSubscribedPlatinum ||
      status.isSubscribedPlus,
    color: ColorsEnum.green
  }
];

export const KHATTABAT_USER_FEATURE_SET_ACTIVE_FEATURES = (
  status: TUserSubscriptionStatus
): TKhattabatFeatureBadge[] => [
  {
    tagKey: "BOOST",
    isPaid:
      status.isPaidVIP ||
      status.isPaidGold ||
      status.isPaidPlatinum ||
      status.isPaidPower ||
      status.isPaidBoost,
    isSubscribed:
      status.isSubscribedVIP ||
      status.isSubscribedGold ||
      status.isSubscribedPlatinum ||
      status.isSubscribedPower ||
      status.isSubscribedBoost,
    color: ColorsEnum.vipGold
  },
  {
    tagKey: "REWIND",
    isPaid:
      status.isPaidSilver ||
      status.isPaidGold ||
      status.isPaidPlatinum ||
      status.isPaidPower ||
      status.isPaidRewind,
    isSubscribed:
      status.isSubscribedSilver ||
      status.isSubscribedGold ||
      status.isSubscribedPlatinum ||
      status.isSubscribedPower ||
      status.isSubscribedRewind,
    color: ColorsEnum.purple
  },
  {
    tagKey: "READ",
    isPaid: status.isPaidGold || status.isPaidPlatinum || status.isPaidPower,
    isSubscribed:
      status.isSubscribedGold ||
      status.isSubscribedPlatinum ||
      status.isSubscribedPower,
    color: ColorsEnum.powerPurple
  },
  {
    tagKey: "CONVERSATION_BADGE",
    isPaid: status.isPaidGold || status.isPaidPlatinum,
    isSubscribed: status.isSubscribedGold || status.isSubscribedPlatinum,
    color: ColorsEnum.darkOrange
  },
  {
    tagKey: "LIKES",
    isPaid:
      status.isPaidSilver ||
      status.isPaidGold ||
      status.isPaidPlatinum ||
      status.isPaidPlus,
    isSubscribed:
      status.isSubscribedSilver ||
      status.isSubscribedGold ||
      status.isSubscribedPlatinum ||
      status.isSubscribedPlus,
    color: ColorsEnum.green
  }
];

export const USER_DATA_KEYS: TUserKeys[] = [
  "userId",
  "username",
  "deviceId",
  "phoneDetails",
  "gender",
  "status",
  "statusChangeDate",
  "createdOn",
  "createdFrom",
  "lastLogin",
  "deactivatedOn",
  "wasPaying",
  "freemiumSilverUntil",
  "payingSilverUntil",
  "freemiumGoldUntil",
  "payingGoldUntil",
  "freemiumPlatinumUntil",
  "payingPlatinumUntil",
  "payingPowerUntil",
  "freemiumVIPUntil",
  "payingVIPUntil",
  "freemiumPLUSUntil",
  "payingPLUSUntil",
  "payingKhattabatUntil",
  "temporaryBannedCount",
  "warningCount",
  "reportsSent",
  "reportsReceived",
  "referralCode",
  "originCountry",
  "residenceCountry",
  "cityName",
  "selfieVerificationCompletedOn",
  "numberOfVerifiedApprovedPictures",
  "verificationStatus",
  "verificationCode",
  "facebookVerify",
  "smsVerify",
  "emailVerify",
  "appleVerify",
  "emailNotification",
  "pushNotification",
  "loginCount",
  "ipAddress",
  "mobileAppPlatform",
  "mobileAppVersion",
  "userAppLanguage",
  "device_token",
  "religion",
  "subreligion",
  "profilePublicID",
  "khattabaAssigned"
];
